import React, { useState, useEffect, useMemo } from 'react';
import moment from 'moment';
import {
  useParams,
  Link,
  NavLink,
} from 'react-router-dom';

import meta from '../../config/meta.js';
import env from '../../config/env.js';

import Header from '../layout/Header.jsx';
import SearchAssignments from '../blocks/SearchAssignments.jsx';
import ReadingMissions from '../blocks/ReadingMissions.jsx';
import Tabs from '../layout/Tabs.jsx';
import useQuery from '~/commons/hooks/useQuery';
import useHttpStatus from '~/commons/hooks/useHttpStatus';

const PageReadingMissions = () => {
  const { assignmentId } = useParams();
  meta.set({ title: '閱讀任務' });

  return (
    <div>
      <header
        className="missions-header d-flex position-relative justify-content-center align-items-center -min-vh-30"
        style={{
          height: '180px',
          background: 'linear-gradient(180deg, #4EB2FF 0%, #169CFD 100%)',
        }}
      >
        <img className="left" src="/assets/img/mission-reading-header-left.png"/>
        <img className="right" src="/assets/img/mission-reading-header-right.png"/>
        <div className="container-fluid overflow-hidden">
          <div className="row justify-content-center align-items-center">
            <div className="col text-left">
              <div className="row justify-content-center align-items-end">
                <div className="col d-none d-md-flex justify-content-center">
                  <img src="/assets/img/boy.png" className="px-2 pb-3" height="149"/>
                  <img src="/assets/img/girl.png" className="px-2 pt-3" height="148"/>
                </div>
              </div>
            </div>
            <div className="col col-auto">
              <div className="missions-banner-title-box">
                <img className="left" src="/assets/img/lam.png"/>
                閱讀任務
                <img className="right" src="/assets/img/book.png"/>
              </div>
            </div>
            <div className="col text-right position-relative">

                <Link className="missions-banner-back-box btn btn-link"
                  to="/app"
                >
                  <img src="/assets/img/back.svg" alt="返回主頁"/>
                  返回主頁
                </Link>

            </div>
          </div>
        </div>
      </header>
      <ReadingMissions
        assignments={env.assignments}
        assignmentId={assignmentId}
      />
    </div>
  );
};

export default PageReadingMissions;
